import { createAction } from '@reduxjs/toolkit';

import { PREVENT_DETECTING_AUTHENTICATED_USER, OBSERVE_DETECTING_AUTHENTICATED_USER } from 'constants/redux-actions';

const preventDetectingAuthenticatedUser = createAction(PREVENT_DETECTING_AUTHENTICATED_USER);

const observeDetectingAuthenticatedUser = (visible) => createAction(OBSERVE_DETECTING_AUTHENTICATED_USER)(visible);

const implicitAuthActions = { preventDetectingAuthenticatedUser, observeDetectingAuthenticatedUser };

export default implicitAuthActions;
